function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.3141 33.6598C32.5878 33.6598 30.9642 32.9876 29.7436 31.7674L23.144 25.168C22.6808 24.7034 21.8731 24.7048 21.4099 25.168L14.7863 31.7916C13.5655 33.0116 11.942 33.6838 10.2156 33.6838H8.9151L17.2734 42.0423C19.8839 44.6526 24.1162 44.6526 26.7267 42.0423L35.1092 33.6598H34.3141Z",
  fill: "#32BCAD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2156 10.316C11.9419 10.316 13.5655 10.9883 14.7861 12.2085L21.4097 18.8332C21.8867 19.3102 22.6657 19.3123 23.144 18.8326L29.7434 12.2325C30.9642 11.0124 32.5877 10.3402 34.3141 10.3402H35.109L26.7267 1.95786C24.1162 -0.65262 19.8839 -0.65262 17.2734 1.95786L8.91528 10.316H10.2156Z",
  fill: "#32BCAD"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M42.0423 17.2735L36.9768 12.2079C36.8652 12.2526 36.7446 12.2806 36.6171 12.2806H34.3142C33.1234 12.2806 31.9578 12.7634 31.1166 13.6053L24.5169 20.2049C23.8996 20.8225 23.0881 21.1317 22.2773 21.1317C21.4658 21.1317 20.655 20.8225 20.0375 20.2056L13.4132 13.5813C12.5717 12.7394 11.4064 12.2566 10.2156 12.2566H7.38368C7.26303 12.2566 7.15004 12.228 7.04346 12.1879L1.95786 17.2735C-0.652619 19.8837 -0.652619 24.1161 1.95786 26.7268L7.04325 31.8122C7.14983 31.772 7.26303 31.7435 7.38368 31.7435H10.2156C11.4064 31.7435 12.5717 31.2606 13.4132 30.4188L20.0368 23.7951C21.2341 22.5989 23.3209 22.5983 24.5169 23.7957L31.1166 30.3946C31.9578 31.2366 33.1234 31.7195 34.3142 31.7195H36.6171C36.7448 31.7195 36.8652 31.7472 36.977 31.7919L42.0423 26.7268C44.6528 24.1161 44.6528 19.8837 42.0423 17.2735Z",
  fill: "#32BCAD"
});

var SvgPix = function SvgPix(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPix, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pix.afbfda76.svg";
export { ForwardRef as ReactComponent };